module.exports = __webpack_public_path__ + "img/landing1Large.bf503699.jpg";